import { FormInstance, Upload, UploadFile, UploadProps, message } from 'antd'
import React from 'react'
import { InboxOutlined } from '@ant-design/icons'
import { UploadChangeParam } from 'antd/lib/upload'
import type { UploadRequestOption } from 'rc-upload/lib/interface'
import { uploadFileToGCS } from '../../../../../../../service/gcs-upload.service'

const { Dragger } = Upload

interface InputDragUploadImgProps {
    form: FormInstance
    name: string
    initialValue?: string
    forMobile: boolean
}

const InputDragUploadImg: React.FC<InputDragUploadImgProps> = ({
    form,
    name,
    initialValue,
    forMobile,
}) => {
    const [imageUrl, setImageUrl] = React.useState<string>('')
    const [fileList, setFileList] = React.useState<UploadFile[]>([])

    React.useEffect(() => {
        if (initialValue) {
            const urlSegments = initialValue.split('/')
            const lastSegment = urlSegments[urlSegments.length - 1]
            const fileName = lastSegment.split('?')[0]
            setImageUrl(initialValue)
            setFileList([{ url: initialValue, uid: '', name: fileName }])
        }
    }, [form, initialValue, name])

    const customRequest = async (options: UploadRequestOption) => {
        const { file, onProgress, onSuccess, onError } = options
        try {
            const result = await uploadFileToGCS(
                file as File,
                'image',
                (percent) => onProgress?.({ percent } as unknown as ProgressEvent)
            )
            setImageUrl(result.url)
            form.setFieldValue(name, result.url)
            message.success(`${(file as File).name} อัปโหลดไฟล์เสร็จสิ้น`)
            onSuccess?.(result)
        } catch (err) {
            message.error(
                `${(file as File).name} อัปโหลดไฟล์ล้มเหลว: ${(err as Error).message}`
            )
            onError?.(err as Error)
        }
    }

    const uploadProps: UploadProps = {
        name: 'image',
        multiple: false,
        accept: 'image/jpg, image/png, image/jpeg',
        maxCount: 1,
        fileList,
        customRequest,
        onChange: (info: UploadChangeParam) => {
            setFileList(info.fileList)
        },
        onPreview: async (file: UploadFile) => {
            window.open(file.url || file.response?.url, '_blank')
        },
        onRemove: () => {
            form.setFieldValue(name, undefined)
        },
    }

    const styles = {
        color: `${form.getFieldError(name).length !== 0 ? 'red' : ''}`,
    }

    return (
        <Dragger
            maxCount={1}
            {...uploadProps}
            style={{
                width: '507px',
                height: '285px',
                borderColor: `${
                    form.getFieldError(name).length !== 0 ? 'red' : ''
                }`,
            }}
        >
            {fileList.length === 0 ? (
                <>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined style={styles} />
                    </p>
                    <p className="ant-upload-text">เลือกไฟล์หรือลากมาที่นี่</p>
                    <p className="ant-upload-hint">
                        อัตราส่วนที่แนะนำคือ {forMobile ? '4:5' : '16:9'}
                        <br />
                        รองรับการอัปโหลดไฟล์ PNG, JPG, JPEG เท่านั้น
                    </p>
                </>
            ) : (
                <img src={imageUrl} alt="Preview" style={{ width: '100%' }} />
            )}
        </Dragger>
    )
}

export default InputDragUploadImg
